var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-5"},[_vm._v("Responses")]),_vm._l((_vm.responses),function(response,key){return _c('response-row',{key:key,attrs:{"response":response}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }